import { UserCartResponse, UserCartResponseState } from './userCart'

function mapMerchandiseItem(item: UserCartResponse['result']['items'][number]): App.Checkout.MerchandiseItem {
  return {
    itemId: item.itemId,
    itemType: 'merchandise',
    offerId: (item as any).advertId,
    variantId: (item as any).variantId,
    transactionKey: item.transactionKey,
  }
}

// TODO map contract at item level
export function mapUserCartResponse(response: UserCartResponse): UserCartResponseState {
  const items: App.UserCartState['items'] = {}
  const itemStates: App.UserCartState['itemStates'] = {}
  response.result.items?.forEach(item => {
    if ('saveForLater' in item) {
      const { saveForLater, ...rest } = item
      if ((item as any).itemType === 'merchandise') {
        items[item.itemId] = mapMerchandiseItem(item)
      } else {
        items[item.itemId] = rest as App.Checkout.AnyItem
      }
      itemStates[item.itemId] = { deleted: false, saveForLater: !!saveForLater }
    } else {
      if ((item as any).itemType === 'merchandise') {
        items[item.itemId] = mapMerchandiseItem(item)
      } else {
        items[item.itemId] = item as App.Checkout.AnyItem
        itemStates[item.itemId] = { deleted: false, saveForLater: false }
      }
    }
  })

  return {
    items,
    itemStates,
    connectedRoomOfferIds: response.result.connectedRoomOfferIds,
    updatedAt: response.result.updatedAt,
  }
}

// TODO map contract at item level
export function mapUserCartRequest(userCartState: App.UserCartState) {
  return {
    items: Object.values(userCartState.items)
      .filter(item => !userCartState.itemStates[item.itemId]?.deleted)
      .map(item => ({
        ...item,
        saveForLater: userCartState.itemStates[item.itemId]?.saveForLater,
      })),
    connectedRoomOfferIds: userCartState.connectedRoomOfferIds,
  }
}
